<template>
  <div class="history-pagination" v-if="canShowPagination()">
    <div>
      <el-pagination
        size="mini"
        :page-size="pageSize"
        layout="prev, pager, next"
        @current-change="setCurrentPage"
        :total="totalItems">
      </el-pagination>
    </div>
    <div>
      <el-select v-model="pageSize" size="mini" :title="$t('component.history.list.a11y.pageSizeSelect')">
        <el-option
          v-for="item in pageSizes"
          :key="item"
          :label="item"
          :value="item">
        </el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
import HistoryPaginationMixin from '@/common/mixins/History/Pagination.mixin'

export default {
  name: 'HistoryPagination',
  mixins: [HistoryPaginationMixin]
}
</script>
